/**
 * 高度はフィート表示にする（距離・GPS精度はメートルのまま。フィートを使う理由が
 * 高度だけなので）。内部のデータ（FixSample など）はメートルのまま保持し、
 * 表示直前にここで変換する。
 */
export function metersToFeet(m: number): number {
  return m / 0.3048;
}

export function feetToMeters(ft: number): number {
  return ft * 0.3048;
}
